/* istanbul ignore file */
export function initPolyfills(m) {
    Object.keys(m).forEach(function (x) {
        try {
            typeof m[x] === "function" && m[x]();
        }
        catch (e) {
            console.error("## ERR while polyfilling -> ", e);
        }
    });
}
//# sourceMappingURL=initPolyfills.js.map